import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from './global-components/navbar-v2';
import Footer from './global-components/footer-v2';
import Scrollp from './Scroll-Parallax/scrollp';
import FormulaireInscriptionEnLigne from './global-components/formulaire-inscritenligne';

const ActualitesDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { id } = useParams();
  const [actualite, setActualite] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const jour = String(date.getDate()).padStart(2, '0');
    const mois = String(date.getMonth() + 1).padStart(2, '0');
    const annee = date.getFullYear();
    return `${jour}/${mois}/${annee}`;
  };

  const stripHtml = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  };

  const Url = process.env.REACT_APP_URL_DEV;

  useEffect(() => {
    if (!id || !Url) {
      console.error("ID ou URL de l'API manquant !");
      return;
    }

    axios
      .get(`${Url}/api/actualites/id/${id}`)
      .then((response) => {
        if (response.data && response.data.data) {
          setActualite(response.data.data);
        } else {
          console.error('⚠️ Aucune donnée reçue pour cet ID.');
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération de l'actualité:", error);
      });
  }, [id, Url]);

  const handleOpenPopup = () => setIsPopupVisible(true);
  const handleClosePopup = () => setIsPopupVisible(false);
  const toggleContent = () => setIsExpanded(!isExpanded);

  if (!actualite) {
    return (
      <p style={{ color: 'red', textAlign: 'center', fontSize: '18px' }}>
        ⚠️ Chargement ou actualité introuvable...
      </p>
    );
  }

  const plainTextArticle = stripHtml(actualite.actualitesArticle || '');
  const shortArticle = plainTextArticle.slice(0, 300);

  // Styles inline pour l'image
  const imageStyle = {
    width: '100%',
    maxHeight: '600px',
    objectFit: 'contain',
    borderRadius: '8px',
    marginBottom: '20px',
  };

  return (
    <div>
      <Navbar />

      <div className="container15">
        <img
          src={`${Url}/images/${actualite.actualitesImage}`}
          alt={actualite.actualitesTitre}
          style={imageStyle}
        />
        <h2>{actualite.actualitesTitre}</h2>
        <p className="article-meta">
          <strong>Posté par:</strong> {actualite.actualitesPostedBy} |
          <strong> Catégorie:</strong> {actualite.actualitesCategorie} |
          <strong> Date:</strong> {formatDate(actualite.actualitesDate)}
        </p>

        <div className="article-content">
          <p
            dangerouslySetInnerHTML={{
              __html: actualite.actualitesDescription || '',
            }}
          ></p>

          {actualite.actualitesArticle && isExpanded ? (
            <div
              dangerouslySetInnerHTML={{
                __html: actualite.actualitesArticle,
              }}
            />
          ) : (
            <p>
              {shortArticle}
              {plainTextArticle.length > 300 ? '...' : ''}
            </p>
          )}

          {plainTextArticle.length > 100 && (
            <button onClick={toggleContent} className="btn btn-link mt-2">
              {isExpanded ? 'Voir moins' : 'Voir plus'}
            </button>
          )}
        </div>
      </div>

      <Footer />
      <Scrollp />

      <div className="fixed-buttons">
        <Link to="/Formateur">
          <button className="btn btn-primary">Devenir formateur</button>
        </Link>
        <button onClick={handleOpenPopup} className="btn btn-secondary">
          Inscription en ligne
        </button>
      </div>

      {isPopupVisible && (
        <div className="popup-overlay">
          <div className="popup-content">
            <FormulaireInscriptionEnLigne />
            <button onClick={handleClosePopup} className="popup-close-button">
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActualitesDetails;
